// Resume from a real login/voice gesture; this does not open the microphone.
let primed: AudioContext | undefined;
export function primeAvatarAudio() {
  try {
    if (!primed || primed.state === "closed") primed = new AudioContext();
    void primed.resume().catch(() => {});
  } catch {
    /* Text and manual work remain available. */
  }
}
export function takeAvatarAudio() {
  try {
    if (!primed || primed.state === "closed") primed = new AudioContext();
    // The renderer owns disposal. Retaining this reference lets a later human
    // Enable audio gesture resume the very same context used for lip sync.
    return primed;
  } catch {
    return undefined;
  }
}
